import { render, staticRenderFns } from "./RequestLoginData.vue?vue&type=template&id=1bca980b&scoped=true"
import script from "./RequestLoginData.vue?vue&type=script&lang=js"
export * from "./RequestLoginData.vue?vue&type=script&lang=js"
import style0 from "./RequestLoginData.vue?vue&type=style&index=0&id=1bca980b&prod&scoped=true&lang=css"
import style1 from "./RequestLoginData.vue?vue&type=style&index=1&id=1bca980b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca980b",
  null
  
)

export default component.exports